// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\SmsSentResponse

import { SmsType } from './enums.gen';
import { DateTimefromISO } from '#lib/helper/date.js';
import type { DateTime } from 'luxon';

export type SmsSentApiResponse = {
	id: number;
	type: SmsType;
	content: string;
	sent_at: string;
	phone_number: string;
	business: string;
};

export type SmsSent = {
	id: number;
	type: SmsType;
	content: string;
	sent_at: DateTime;
	phone_number: string;
	business: string;
};

export function hydrateSmsSent(data: SmsSentApiResponse): SmsSent {
	return {
		...data,
		sent_at: DateTimefromISO(data.sent_at)!,
	};
}